define(function (require) {
	"use strict";
	var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
	var LobEditView = require("personalization-user-management-views/LobEditView");
    var ERROR_CODES = require("codeTables/errorCodes.json");
	var Settings = require("codeTables/settings.json");

	var LobEditController={};
	function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

		LobEditController = BaseFeatureController.extend({
			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "LobEditController:initialize", options);
				this.siteSettingsModel = options.siteSettingsModel;
				this.lobEditView = new LobEditView({
					anchorSelector: options.featureOptions.anchorSelector,
					lobSiteSettingValue: this.siteSettingsModel.getValue()
				});
				this.listenTo(this.lobEditView, "lob:save", this._save, this);
			},

			getEditView: function (options) {
				LEPersonalization.logger.debug("return this view", "LobEditController:getEditView", options);
				return this.lobEditView;
			},

			_save: function (options) {
				LEPersonalization.logger.debug("save site settings", "LobEditController:_saveSiteSettings");
				LEPersonalization.loader.setLoader();
				options = options || [];
				this.siteSettingsModel.setValue(options[Settings.SETTING_ID.LOB_ENABLED]);
				this.siteSettingsModel.save(null,{
					success: _.bind(this._onSaveSuccess, this),
					error: _.bind(this._onSaveError, this)
				});
			},
            _showNotifierError: function(response) {
                if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision) {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1001"));
                } else {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                }
            },

			_onSaveSuccess: function (model, response) {
				LEPersonalization.logger.debug("When data fetch was successful", "LobEditController:_onSaveSuccess", response);
				LEPersonalization.loader.closeLoader();
				this._performRefresh();
			},

			_onSaveError: function (model, response) {
				LEPersonalization.logger.debug("When data fetch has resulted with an error", "LobEditController:_onSaveError", response);
                this._showNotifierError(response);
				LEPersonalization.loader.closeLoader();
			},

			_performRefresh: function () {
				LEPersonalization.logger.info("Applying lob setting change", "LobEditController:_performRefresh");
				LE.isSilentLeave = true;
				window.location.reload();
			}
		});
	}

	LE.module("LEPersonalization", moduleDefinition);

	return LobEditController;
});
